'use strict';

const React = require('react');
const FooterService = require('./FooterService');
const FooterDestination = require('./FooterDestination');

const Footer = (props) => {
	const teasersModel = props.model.footer_teasers;
	const linksModel = props.model.footer_links;
	return (
		<section className="svtse_section svtse_section--footer">
			<footer className="svtse_footer" role="contentinfo">
				<nav className="svtse_footer-nav" role="navigation">
					{/* Links to programs */}
					<FooterDestination model={teasersModel}/>
					{/* Links to SVT.se  */}
					<FooterService model={linksModel} />
				</nav>
			</footer>
		</section>
	);
};

module.exports = Footer;



/** WEBPACK FOOTER **
 ** ./app/components/Footer/index.js
 **/